import * as Dropzone from 'dropzone';


const AuthApiRoute = '/api/authentication/check';
const DropzoneLib = (Dropzone as any).Dropzone;

export function dropzoneInit() {

    // Auto-discovery only runs if the bundle loads before the document is complete,
    // so disable it and attach the instance explicitly below.
    DropzoneLib.autoDiscover = false;

    var dropzoneArea = document.getElementById("dropzoneForm");
    let bootstrap = (window as any).bootstrap;
    let redirectUrl = bootstrap ? `${bootstrap.loginPageUrl}?ReturnUrl=${window.location.href}` : '';

    if (dropzoneArea && !(dropzoneArea as any).dropzone) {
        new DropzoneLib(dropzoneArea, {
            autoProcessQueue: false,
            dictDefaultMessage: (window as any).bootstrap.dragAndDropText,
            addRemoveLinks: true,
            uploadMultiple: false,
            acceptedFiles: ".csv",
            createImageThumbnails: false,

            init: function () {
                var submitButton = document.querySelector("#submit-all");
                var myDropzone = this; //closure

                submitButton.addEventListener("click", async function () {

                    let authenticated = await isAuthenticated();
                    if (!authenticated) {
                        window.location.href = redirectUrl;
                        return;
                    }

                    //tell Dropzone to process all queued files
                    myDropzone.processQueue();
                });

                this.on("complete", async function (data) {
                    if (data.status !== "error") {
                        var res = JSON.parse(data.xhr.responseText);
                        document.getElementById("jsResponseMessage").innerText = res.message;
                        document.getElementById("jsResponseDescription").innerText = res.description;
                    }
                });

                this.on("addedfile", function () {
                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }
                });
            }
        });
    }

}

async function isAuthenticated(): Promise<boolean> {

    return await window.fetch(AuthApiRoute, { method: 'get' })
        .then(response => response.json())
        .then(response => {
            return response.authenticated;
        });
}

